document.addEventListener('alpine:init', () => {
    Alpine.data('searchableSelect', () => ({
        tomSelect: null,
        select: null,
        originalDisplay: '',
        originalClassName: '',
        ready: false,

        init() {
            const el =
                this.$el.tagName === 'SELECT'
                    ? this.$el
                    : this.$el.querySelector('select');

            if (!window.TomSelect || !el) {
                return;
            }

            this.select = el;
            this.originalDisplay = el.style.display;
            this.originalClassName = el.className;
            el.style.display = 'none';
            el.classList.remove(
                'form-control',
                'form-control-sm',
                'custom-select',
                'custom-select-sm'
            );

            this.tomSelect = new window.TomSelect(el, {
                plugins: ['dropdown_input'],
                allowEmptyOption: true,
                placeholder: el.dataset.placeholder || '',
            });
            this.ready = true;
            this.$el.classList.add('searchable-select--ready');
        },

        destroy() {
            if (this.tomSelect) {
                this.tomSelect.destroy();
                this.tomSelect = null;
            }

            if (this.select) {
                this.select.style.display = this.originalDisplay;
                this.select.className = this.originalClassName;
                this.select = null;
                this.originalDisplay = '';
                this.originalClassName = '';
            }

            this.ready = false;
            this.$el.classList.remove('searchable-select--ready');
        },
    }));
});
